import { Component, Input, OnInit } from "@angular/core";
import { OdontogramaConfigService } from "app/services/odontograma-config.service";
import { EstadoOdontograma } from "app/models/odontograma.interface";
import { CondicionConfig } from "app/shared/odontograma/catalogo-condiciones";

@Component({
  selector: "app-odontograma-detalle",
  templateUrl: "./odontograma-detalle.component.html",
  styleUrls: ["./odontograma-detalle.component.scss"],
})
export class OdontogramaDetalleComponent implements OnInit {
  @Input() estado: EstadoOdontograma = {};
  @Input() denticion: "adulto" | "nino" | "mixta" = "adulto";

  constructor(public configService: OdontogramaConfigService) {}

  ngOnInit(): void {
    this.configService.cargar().subscribe();
  }

  leyenda(): CondicionConfig[] {
    const usadasCara = new Set<string>();
    const usadasDiente = new Set<string>();

    for (const entry of Object.values(this.estado)) {
      if (entry?.tooth) usadasDiente.add(entry.tooth);
      if (entry?.surfaces) {
        for (const cond of Object.values(entry.surfaces)) {
          if (cond) usadasCara.add(cond as string);
        }
      }
    }

    const cara = this.configService.cara.filter((c) => usadasCara.has(c.codigo));
    const diente = this.configService.diente.filter((c) => usadasDiente.has(c.codigo));
    return [...cara, ...diente];
  }

}
